export default {"src":"/_next/static/media/Innovative Treatments.53fc7e41.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};